export default {
  integration: {
    pageTitle: '渠道管理',
    pageDesc: '管理微信小程序和抖音小程序授权，授权后可使用对应平台能力。',

    wechatCardTitle: '微信小程序',
    douyinCardTitle: '抖音小程序',
    alipayCardTitle: '支付宝小程序',
    unionPayCardTitle: '云闪付小程序',
    xiaohongshuCardTitle: '小红书小程序',
    harmonyCardTitle: '鸿蒙元服务',
    notAuthorized: '尚未授权',
    notAuthorizedShort: '未授权',
    notAuthorizedDesc: '授权后，小程序就能使用本品牌的门店、商品和会员服务。',
    douyinDesc: '点击去授权后，请按抖音页面提示完成绑定。',
    waitingAuthorization: '待授权',
    noMiniProgramTip: '没有小程序？',
    registerNow: '去注册',
    customize: '定制小程序',
    customizeDesc: '自定义小程序页面布局与展示内容。',
    customizeAuthorizedDesc: '调整小程序页面布局，配置轮播图、商品展示与导航入口，打造符合品牌风格的小程序。',
    authorizeNow: '去授权',
    scanToVisit: '微信“扫一扫”访问小程序',
    qrCodeAlt: '微信小程序码',
    qrCodeUnavailable: '暂无小程序码',
    qrCodeUnavailableDesc: '小程序码暂未生成，可点击“刷新小程序码”重试。',
    refreshQrCode: '刷新小程序码',
    refreshQrCodeSuccess: '小程序码已刷新',
    downloadQrCode: '下载小程序码',
    downloadQrCodeSuccess: '小程序码已下载',
    downloadQrCodeFailed: '小程序码下载失败，请重试',

    appName: '小程序名称',
    externalAppId: '小程序 AppID',
    principalName: '主体名称',
    miniProgramIntroduction: '小程序简介',
    authorizationId: '授权ID',
    status: '授权状态',
    revision: '版本号',
    lastSyncedTime: '最近同步时间',

    statusAuthorized: '已授权',
    statusRevoked: '已撤销',
    statusInvalid: '已失效',

    startAuth: '发起授权',
    reAuth: '重新授权当前小程序',
    refreshMirror: '刷新授权状态',
    refreshSuccess: '授权状态已刷新',
    refreshRemoteMissing: '暂未查询到有效授权，请确认平台授权已完成',
    deauthorizationGuide: '解除授权指引',
    deauthorizationGuideTitle: '解除微信小程序授权',
    deauthorizationGuideNotice: '微信要求由小程序管理员在微信公众平台完成解除授权，服务商无法代为操作。',
    deauthorizationGuideStep1: '使用小程序管理员账号登录微信公众平台。',
    deauthorizationGuideStep2: '进入“设置 → 第三方设置”。',
    deauthorizationGuideStep3: '找到当前授权的第三方平台，并按页面指引解除授权。',
    deauthorizationGuideResult: '解除成功后，授权状态将自动更新为“已撤销”。',
    openWechatPublicPlatform: '打开微信公众平台',

    manageMiniProgram: '管理小程序',
    managePageTitle: '管理小程序',
    managePageDesc: '查看微信小程序授权信息，并提交或发布小程序版本。',
    basicInfoTitle: '基本信息',
    basicInfoDesc: '当前已授权的小程序信息。',
    refreshBasicInfo: '刷新基本信息',
    refreshBasicInfoSuccess: '基本信息已刷新',
    authorizationPlatform: '授权平台',
    noAuthorizedMiniProgram: '暂无已授权的小程序信息',
    versionInfoTitle: '版本管理',
    versionInfoDesc: '提交后，系统会上传最新小程序版本并送微信审核。',
    queryAuditStatus: '查询审核状态',
    queryAuditStatusSuccess: '审核状态已更新',
    versionOperationResultUnknown: '操作结果暂时无法确认，请重新进入页面确认最新状态后再继续。',
    submitNewVersion: '提交新版本',
    releaseVersion: '发布版本',
    submitVersionConfirm: '确认提交新的小程序版本给微信审核吗？',
    releaseVersionConfirm: '确认发布这个已通过审核的小程序版本吗？',
    submitVersionSuccess: '新版本任务已提交',
    releaseVersionSuccess: '发布任务已提交',
    noVersionTask: '暂无版本任务',
    noVersionTaskDesc: '还没有提交记录。提交新版本后，可在这里查看审核进度。',
    reviewProgressTitle: '版本审核进度',
    reviewStepSubmit: '提交审核',
    reviewStepWechat: '微信审核',
    reviewStepResult: '审核结果',
    reviewPassed: '审核通过',
    reviewTipPending: '提交审核后，可在当前页查看审核状态。微信一般会在 3-4 个工作日内完成审核，具体以微信审核结果为准。',
    reviewTipReviewing: '微信一般会在 3-4 个工作日内完成审核。当前仍在常规审核时间内，请查询审核状态。',
    reviewTipOverdue: '本次审核已超过 4 个工作日。请以微信审核结果为准，并查询审核状态。',
    reviewTipPassed: '最新版本已通过微信审核，可以发布版本。',
    currentOnlineVersion: '当前线上版本',
    onlineReleaseTime: '上次发布时间',
    latestAvailableVersion: '开放平台最新版本',
    latestVersionNotFetched: '未获取',
    getLatestVersion: '获取最新版本',
    getLatestVersionSuccess: '已获取最新版本',
    checkingUpgradeAvailability: '正在检查新版本',
    alreadyLatestVersion: '当前已是最新版本',
    taskTemplateVersion: '上次提审版本',
    versionStatus: '版本状态',
    submittedTime: '上次提审时间',
    statusSubmitting: '正在提交新版本',
    statusUnderReview: '微信审核中',
    statusReviewRejected: '审核未通过',
    statusReadyToRelease: '审核通过，待发布',
    statusReleasing: '正在发布',
    statusReleaseFailed: '发布失败，可重新发布',
    statusReleased: '已发布',
    statusFailed: '版本操作失败',

    authDialogTitle: '完成授权',
    authDialogTip: '请在新打开的页面中登录平台管理员账号并完成授权。没有看到新页面时，可点击下方按钮重新打开。',
    authEntryExpireAt: '请在此时间前完成授权',
    openEntryUrl: '打开授权页面',

    sessionStatus: '会话状态',
    sessionPending: '等待授权中…',
    sessionAuthorized: '授权成功',
    sessionFailed: '授权失败',
    sessionExpired: '授权链接已过期，请重新发起授权',
    failureReason: '失败原因',
    createSessionFail: '授权页面打开失败，请稍后重试',
    done: '完成',
  },
};
